import React, { useState, useEffect } from 'react';
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import { CompTextFieldNew } from '../../../components/newComponents/TextField';
import { useTranslation, withTranslation } from "react-i18next";
import {connect} from "react-redux";
import { changePasswordAPICallError, setPasswordChanged, changePassword } from '../../changepass/changepass.actions';
import AppHeader from '../../../components/newComponents/AppHeader';
import Alert from '@mui/material/Alert';
import { ReactComponent as ErrorIcon } from "../../../styles/images/IconError.svg"
import { ButtonPrimary } from '../../../components/newComponents/ButtonPrimary';
import { useParams } from 'react-router-dom';

const ChangePasswordNew = (props) => {
    const { t, i18n } = useTranslation('translation');

    const logoLang = i18n.language === 'fi' ? 'Logo_nuodo_login_new2025' : 'Logo_ungdo_login_new2025';
    const logoSrc = `${process.env.PUBLIC_URL}/media/images/${logoLang}.svg`;

    const { userId } = useParams();
    const { hash } = useParams();
    const { key } = useParams();

    const min_pass_length = 8;

    const [values, setValues] = useState({
        password: '',
        passwordAgain: '',
    });

    const [error, setError] = useState({});
    const [isPasswordChanged, setIsPasswordChanged] = useState(false);

    useEffect(() => {
        document.title = t('change_password.title') + " - " + t('common.title');
    }, [t]);

    const handleChange = (event) => {
        setValues((prev) => ({
            ...prev,
            [event.target.name]: event.target.value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (values.password !== values.passwordAgain) {
            setError({ passwordAgain: t("change_password.password_miss_match") });
            return;
        }
        if (values.password.length < min_pass_length) {
            setError({ passwordAgain: t("change_password.password_too_short") });
            return;
        }
        if (!(/\d/.test(values.password)) ||
            !(/[a-zåäö]/.test(values.password)) ||
            !(/[A-ZÅÄÖ]/.test(values.password))) {
            setError({ passwordAgain: t("change_password.must_contain_number_and_uppercase_and_lowercase_characters") });
            return;
        }

        setError({});
        props.changePassword(userId, hash, key, values.password, values.passwordAgain, 
            (data, response) => {
                setIsPasswordChanged(true);
                return setPasswordChanged(data, response);
            }, 
            (err) => {
                setError({ submitError: t("change_password.submit_error") });
                return changePasswordAPICallError(err);
            }
        );
    };

    return (
        <Grid className={'loginRoot'} sx={{paddingLeft: "0px !important", paddingRight: "0px !important", display: 'block'}}>
            <AppHeader />
            <CssBaseline />
            
            <Grid className='site-wrapper loginBackgroundImage' sx={{width: '100%', paddingLeft: '20vh'}}>
            <Grid className='login-box-wrapper' component={Paper} elevation={6} square size={{ xs: 12, sm: 9, md: 6 }} sx={{ height: '90vh'}}>
            {isPasswordChanged ? 
                <Grid className={'pwChanged_wrapper'} container spacing={4}>
                    <div className='paperHeader'>
                        <img className='login-logo'
                            src={logoSrc} alt={t('common.youth_work')} 
                        />
                    </div>
                    <Typography component="h1" variant="h4" gutterBottom>
                        {t('change_password.title')}
                    </Typography>
                    <Typography align={'left'} gutterBottom>
                        {t('change_password.password_changed_descriptionNew')}
                    </Typography>
                    <ButtonPrimary 
                        fullWidth
                        variant="contained"
                        color="primary"
                        href='/login'
                        sx={{width: '200px', height: '40px', margin: '0px !important'}}
                    >
                        {t('change_password.password_changed_send_button')}
                    </ButtonPrimary>
                </Grid>
                : 
                <div className={'paper forgot-pw-paper'}>
                    <div className='paperHeader'>
                        <img className='login-logo'
                            src={logoSrc} alt={t('common.youth_work')} 
                        />
                    </div>
                    <Grid className={'paperContent forgot-pw_paperContent'}>
                        <Grid container spacing={0} sx={{flexDirection: 'column'}}>
                            <Typography component="h1" variant='h4'>
                                {t('change_password.title')}
                            </Typography>
                            <Typography align='center' gutterBottom sx={{marginTop: '5%', textAlign: 'left', marginBottom: '1.35em'}}>
                                {t('change_password.descriptionNew')}
                            </Typography>
                        {error.submitError && (
                            <Alert severity={'error'} iconMapping={{ error: <ErrorIcon fontSize="inherit" /> }}>
                                {error.submitError}
                            </Alert>
                        )}
                        <form className={'form'} noValidate autoComplete="off">
                            <CompTextFieldNew
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label={t('change_password.password')}
                                type="password"
                                isLabelShrink={true}
                                id="password"
                                errorAlreadyTranslated={true}
                                onChange={handleChange}
                                value={values.password}
                                autoComplete="current-password"
                            />
                            <CompTextFieldNew
                                variant="outlined"
                                required
                                fullWidth
                                name="passwordAgain"
                                label={t('change_password.password_again')}
                                type="password"
                                isLabelShrink={true}
                                id="passwordAgain"
                                errorAlreadyTranslated={true}
                                onChange={handleChange}
                                value={values.passwordAgain}
                                error={error.passwordAgain}
                                autoComplete="current-password"
                            />
                            <ButtonPrimary
                                fullWidth
                                variant="contained"
                                color="primary"
                                href="/login"
                                sx={{width: '200px', height: '40px', margin: '0px !important'}}
                                onClick={handleSubmit}
                            >
                                {t('change_password.send_button')}
                            </ButtonPrimary>
                        </form>
                        </Grid>
                    </Grid>
                </div>
                }
                    <Grid container className={'footer-container'}>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <a href={'https://nuorisotilastot.fi/wp-content/uploads/2025/01/2025_01_07_Tietosuojailmoitus_nuodo.pdf'} target='_blank' rel="noopener noreferrer" className={'link-data-privacy'}>
                                {t('footer.privacy_statement')}
                            </a>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <a href={'https://nuorisotilastot.fi/2350/uncategorized/nuodo-info/'} target='_blank' rel="noopener noreferrer" className={'link-accessibility'}>
                                {t('footer.accessibility_statement')}
                            </a>
        
                        </Grid>
                        <Grid /* sx={{width: '33%'}} */
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 3
                            }}>
                            <div className={'copyright'}>© {t('common.application_owner')} {new Date().getFullYear()}</div>
                        </Grid>
                    </Grid>
            </Grid>
            </Grid>
        </Grid>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        changePassword: (userId, hash, key, password, passwordAgain, onSuccess, onFailure) => dispatch(changePassword(userId, hash, key, password, passwordAgain, onSuccess, onFailure)),
        setPasswordChanged: (data, response) => dispatch(setPasswordChanged(data, response))
    };
}

const ChangePassword = connect(
    null,
    mapDispatchToProps
)(withTranslation('translation')(ChangePasswordNew));

export { ChangePassword };